import React from "react"
import InfograficaPage11 from '../../components/Capitolo3/InfograficaPage11'

const Page11 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ height: "100%", background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-6'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          I servizi di Fleet Audit
        </div>
        <div className='lg:mt-3 font-family-acumin xl:mt-2 lg:font-32 xl:font-28 lg:line-height-40 xl:line-height-38'>
          Entrare nel mercato dei veicoli elettrici <br />
          oggi è diventato sinonimo di opportunità: <br />
          l’e-mobility porta benefici anche a chi
          sceglie di introdurla nel proprio business<br />
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Per tutte le realtà che hanno intenzione di passare a una flotta<br />
          che comprenda veicoli elettrici, Edison propone una soluzione<br />
          pensata per facilitare questa importante transizione:<br />
          si tratta del progetto Fleet Audit.
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Edison Fleet Audit offre alle aziende la sicurezza necessaria per<br /> l’elettrificazione
          del proprio parco auto: una scelta che consente di<br />aumentare l’efficienza e tagliare i costi,
          per un futuro dalla parte<br />dell’ambiente e un’imprenditoria green.
        </div>
      </div>
      <div className='col-5'>
        <div className='lg:mt-7 xl:mt-5'>
          <InfograficaPage11 openPercent={openPercent}/>
        </div>
      </div>
    </div>
  )
}

export default Page11
